import { useQuery } from '@apollo/client';
import { ArrowForward } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { SupplierRelationshipType } from '@/generated/gql/graphql';
import { RouteId } from '~/routes';

import { SUPPLIER_MAP_DETAIL_QUERY } from './SupplierMapDetail.gql';
import { MapDetailStyled } from './SupplierMapDetail.styled';
import { SupplierMapDetailContent } from './SupplierMapDetailContent/SupplierMapDetailContent';

export interface SupplierMapDetailProps {
  id: string;
  onClose?: () => void;
}

export const SupplierMapDetail = ({ id, onClose }: SupplierMapDetailProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SupplierMapDetail' });
  const { data, loading } = useQuery(SUPPLIER_MAP_DETAIL_QUERY, {
    variables: {
      id,
    },
  });

  return (
    <MapDetailStyled
      title={data?.supplier.name}
      onClose={onClose}
      footer={
        <Button
          component={RouterLink}
          to={
            data?.supplier.relationship === SupplierRelationshipType.unknown
              ? RouteId.companyDetail(id)
              : RouteId.supplierDetail(id)
          }
          variant="text"
          endIcon={<ArrowForward />}
        >
          {t('buttonMore')}
        </Button>
      }
    >
      <SupplierMapDetailContent loading={loading} data={data?.supplier} />
    </MapDetailStyled>
  );
};
